import { render, staticRenderFns } from "./wf-radio-button-list-with-other-edit.vue?vue&type=template&id=2ca57bc1&scoped=true&"
import script from "./wf-radio-button-list-with-other-edit.vue?vue&type=script&lang=ts&"
export * from "./wf-radio-button-list-with-other-edit.vue?vue&type=script&lang=ts&"
import style0 from "./wf-radio-button-list-with-other-edit.vue?vue&type=style&index=0&id=2ca57bc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca57bc1",
  null
  
)

export default component.exports